export enum IconClass {
  activity = 'activity',
  alignCenter = 'align-center',
  alignJustify = 'align-justify',
  arrowRight = 'arrow-right',
  arrowUpLeft = 'arrow-up-left',
  box = 'box',
  check = 'check',
  codepen = 'codepen',
  command = 'command',
  cornerDownRight = 'corner-down-right',
  cornerLeftDown = 'corner-left-down',
  cpu = 'cpu',
  disc = 'disc',
  download = 'download',
  externalLink = 'external-link',
  fastForward = 'fast-forward',
  globe = 'globe',
  grid = 'grid',
  hash = 'hash',
  logIn = 'log-in',
  link = 'link',
  logOut = 'log-out',
  messageCircle = 'message-circle',
  messageSquare = 'message-square',
  mic = 'mic',
  monitor = 'monitor',
  package = 'package',
  phoneCall = 'phone-call',
  phoneForwarded = 'phone-forwarded',
  phoneIncoming = 'phone-incoming',
  phoneMissed = 'phone-missed',
  phoneOff = 'phone-off',
  phoneOutgoing = 'phone-outgoing',
  play = 'play',
  radio = 'radio',
  refreshCcw = 'refresh-ccw',
  refreshCw = 'refresh-cw',
  rotateCcw = 'rotate-ccw',
  save = 'save',
  server = 'server',
  settings = 'settings',
  share2 = 'share-2',
  shield = 'shield',
  shuffle = 'shuffle',
  star = 'star',
  tag = 'tag',
  zap = 'zap'
}
